<!--<button *ngIf="isReady$ | async" class="btn btn-primary" (click)="onApplyNow(p)">Apply Now</button>-->

<lgv-loading-indicator *ngIf="isLoading$ | async"></lgv-loading-indicator>

<ng-container *ngIf="lgvUserSvc.readyToApply$ | async">
    <ng-container *ngIf="isLinkMode">
        <a (click)="onApplyNow(p)" [ngClass]="CSSClass">{{!!label ? label : 'Apply Now '}}<fa-icon icon="arrow-right"></fa-icon></a>
    </ng-container>
    <ng-container *ngIf="!isLinkMode">
    <button *ngIf="lgvUserSvc.readyToApply$ | async" class="btn btn-primary" (click)="onApplyNow(p)" [ngClass]="CSSClass">{{!!label ? label : 'Apply Now'}}</button>
    </ng-container>
</ng-container>
